import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-template-create',
  templateUrl: './template-create.component.html',
  styleUrls: ['./template-create.component.css']
})
export class TemplateCreateComponent implements OnInit {
  api_error = null;
  api_success = null;
  renewLicenseObj: any = {};
  btndisabled;
  addressAsInGst;
  accId;
  templateName: any;
  type: any;
  constructor(private accountService: AccountService,@Inject(MAT_DIALOG_DATA) public data: number,
  private dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
    this.accId = this.data['accountId'];
    this.type = this.data['type'];

  if(this.type === 'edit'){
    this.templateName = this.data['temp'].templateName;
  }
  }
  submit() {
    this.api_error = '';
    this.api_success = '';
    if (this.templateName === '') {
      this.api_error = 'Please fill template name';
    } else {
      const data = {
        'account': this.accId,
        'templateName': this.templateName
      }
      if(this.type === 'edit'){
        this.accountService.updateTemplate(this.accId, this.data['temp'].id,data)
        .subscribe(res => {
          this.api_success =  'Template Name Updated sucessfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      }
      else{
        this.accountService.createTemplate(this.accId, data)
        .subscribe(res => {
          this.api_success =  'Template Name Created sucessfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      }
      }
     
    

  }
 
}
